import React from "react";
import Links from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useRef, useEffect, useState } from "react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Dropdown } from "primereact/dropdown";
import "./table.css";
import AADHeader from "./components/AADHeader.js";

export default function Home() {
  const username = localStorage.getItem("userName");
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = React.useState(false);
  const [countries, setCountries] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [sitelocation, setSiteLocation] = useState("");
  const [message, setMessage] = useState("");
  const [roleList, setRoleList] = useState("");
  const [roles, setRoles] = useState("");
  const [allsitelocation, setAllSiteLocation] = useState("");

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  async function fetchData() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}roles`);
      const data = await response.json();
      setRoleList(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchsitelocation() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}list-sitelocation`,
        requestOptions
      );

      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setLoading(false);
          setAllSiteLocation();
        } else if (responseJson.status == 400) {
          setLoading(false);
          setAllSiteLocation();
        } else {
          setLoading(false);
          setAllSiteLocation(responseJson.data);
        }
      } else {
        setLoading(false);
        setAllSiteLocation();
      }
    } catch (error) {
      setAllSiteLocation([]);
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchsitelocation();
  }, []);

  let handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const now = new Date();
    let timestamp = now.toISOString();
    try {
      let rest = await fetch(`${process.env.REACT_APP_BASE_API_URL}resgister-user`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          timestamp: timestamp,
          email: email,
          name: name,
          department: department,
          roles: [roles],
          permissions: [],
        }),
      });
      if (rest.status === 200) {
        const responseJson1 = await rest.json();
        if (responseJson1.success === false) {
          setLoading(false);
          // Surface the real backend reason (bad role, no permission, duplicate) instead of a canned message.
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: (typeof responseJson1.data === "string" && responseJson1.data) ? responseJson1.data : "Unable to add user.",
          });
        } else if (responseJson1.status === 400) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson1.title,
          });
        } else {
          setLoading(false);
          await Swal.fire({
            icon: "success",
            html: "User created successfully",
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
          navigate("/listofusers"); // land on the list so the new user is visible
        }
      } else {
        setLoading(false);
        // Non-200 (e.g. permission denied at the proxy) — surface the server's reason, not a canned string.
        let msg = "Something went wrong. Please try again.";
        try {
          const errJson = await rest.json();
          const serverMsg = errJson && (errJson.data || errJson.error || errJson.message);
          if (typeof serverMsg === "string" && serverMsg) msg = serverMsg;
        } catch (_) {}
        Swal.fire({ icon: "error", title: "Oops...", text: msg });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
      // Network/parse failure — give feedback instead of silently stopping the spinner.
      Swal.fire({ icon: "error", title: "Oops...", text: "Unable to reach the server. Please try again." });
    }
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading=""/>;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div class="container formpd">
          <div Class="steps__containt-hader">
            <h3 class="title">Add New User</h3>
            <div role="presentation">
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Links underline="hover" color="#707070" className="breadcrumbs-font">
                  Settings
                </Links>
                <Link
                  to="/listofusers"
                  underline="hover"
                  color="#707070"
                  className="breadcrumbs-font"
                >
                  User List
                </Link>
                <Link underline="hover" color="#707070" className="breadcrumbs-font">
                  Add New User
                </Link>
              </Breadcrumbs>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div className="message">{message ? <p>{message}</p> : null}</div>
              <form onSubmit={handleSubmit} class="form-eco">
                <div class="form-row">
                  <div className="form-group col-md-6">
                    <label className="formlable" htmlFor="inputemail">
                      Email Address<span className="mark-form">*</span>
                    </label>
                    <input
                      type="email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder="Enter email address"
                      pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                      title="Enter a valid email address"
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label className="formlable" htmlFor="inputfullname">
                      Full Name<span className="mark-form">*</span>
                    </label>
                    <input
                      type="text"
                      value={name}
                      required
                      onChange={(e) => {
                        // Check if the entered value contains only alphabets
                        const onlyAlphabets = /^[A-Za-z\s]+$/;
                        if (onlyAlphabets.test(e.target.value) || e.target.value === "") {
                          // If it's valid or empty, update the state
                          setName(e.target.value);
                        }
                      }}
                      className="form-control"
                      placeholder="Enter full name"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="formlable" for="inputdepartment">
                      Department<span className="mark-form">*</span>
                    </label>
                    <input
                      type="text"
                      value={department}
                      required
                      onChange={(e) => {
                        // Check if the entered value contains only alphabets
                        const onlyAlphabets = /^[A-Za-z\s]+$/;
                        if (onlyAlphabets.test(e.target.value) || e.target.value === "") {
                          // If it's valid or empty, update the state
                          setDepartment(e.target.value);
                        }
                      }}
                      class="form-control"
                      placeholder="Enter department"
                    />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="formlable" for="inputState">
                      Site location
                    </label>
                    <Dropdown
                      id="inputSiteLocation"
                      className="form-control wd-100"
                      value={sitelocation || null}
                      onChange={(e) => setSiteLocation(e.value)}
                      options={
                        allsitelocation &&
                        allsitelocation.map((status) => ({
                          label: status.name,
                          value: status.name,
                        }))
                      }
                      placeholder="Select Site Location"
                      filter
                      filterPlaceholder="Search site location"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="formlable" for="inputState">
                      Role <span className="mark-form">*</span>
                    </label>
                    <Dropdown
                      id="inputRole"
                      className="form-control wd-100"
                      required
                      value={roles || null}
                      onChange={(e) => setRoles(e.value)}
                      options={roleList && roleList.map((status) => ({ label: status, value: status }))}
                      placeholder="Select Role"
                      filter
                      filterPlaceholder="Search role"
                    />
                  </div>
                  <div class="form-group col-md-6"></div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    {/* <Checkbox
                 color="primary"
                 className="checkbox-user"
                  />
                <label class="formlable" for="inputState"><span className="mark-form">**Notify the new user about User Creation</span></label> */}
                  </div>
                  <div class="form-group col-md-6"></div>
                </div>
                <Button
                  type="submit"
                  className="next-button"
                  variant="contained"
                  size="medium"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#407775",
                    width: "120px",
                    height: "41px",
                    texttransform: "capitalize",
                    borderRadius: "10px",
                  }}
                  disabled={loading}
                >
                  Submit
                </Button>
                <Button
                  href="listofusers"
                  variant="outlined"
                  size="medium"
                  className="outline-btn"
                  sx={{
                    color: "#000",
                    marginLeft: "15px",
                    width: "120px",
                    height: "41px",
                    borderRadius: "10px",
                  }}
                >
                  Cancel
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
